const formatDateToLocal = (date, showTime = false) => {
    if (!date) { return ''; }

    const d = new Date(date);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };

    if (showTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
    }

    return d.toLocaleDateString('fr-FR', options);
}

const clearLocalStorage = () => {
    localStorage.removeItem('bookingPreviewData');
    localStorage.removeItem('selectedVehicle');
    localStorage.removeItem('searchParameters');
};

export { formatDateToLocal, clearLocalStorage };